import { createSlice } from "@reduxjs/toolkit"

const registerSlice = createSlice({
    name: "register",
    initialState: {
        user : {
            first_name: "",
            last_name: "",
            title: "",
            email: "",
            password: "",
            avatar: "",
            preferences: {},
            contactMethods: {
                email: "",
                phoneNumber: "",
                skype: "",
                whatsapp: "",
            },
            subscriptions: [],
            role: "",
            active: true,
            auto_assign: false,
            auto_assign_role: "",
            client: "",
            accounts: [],
            skills: [],
        },
        client : {
            name: "",
            address: "",
            city: "",
            state: "",
            zip: "",
            country: "",
            email: "",
            phone: "",
            website: "",
            signedDocuments: [],
            accounts: [],
            isDeleted: false,
            isInternal: false,
            active: true,
            billingTerms: { 
                type: "Hourly",
                billingEntity: true 
            },
        },
        account : {
            name: "",
            isDeleted: false,
            isInternal: false,
            active: true,
            billingTerms: { type: "Parent" },
        },
    },
    reducers: {
        checkEmailAvailability() {},
        setNewUser(state, action) {
            const { user } = action.payload;
            return { ...state, user: user };
        },
        setNewClient(state, action) {
            const { client } = action.payload;
            return { ...state, client: client };
        },
        setNewAccount(state, action) {
            const { account } = action.payload;
            return { ...state, account: account };
        },
        setNewDocument(state, action) {
            const { document } = action.payload;
            return { ...state, client: { ...state.client, signedDocuments: [...state.client.signedDocuments, document] } };
        }
    }
});

export const { setNewUser, setNewClient, setNewAccount, setNewDocument, checkEmailAvailability } = registerSlice.actions;
export default registerSlice.reducer;